import { FC } from 'react';

export type LinearDeterminateLoaderProps = {
  durationInMs: number;
};

export const LinearDeterminateLoader: FC<LinearDeterminateLoaderProps> = (props) => {
  return (
    <div className="h-1 w-full bg-black-20">
      <div
        className="h-full animate-progress-bar rounded-[4px] bg-white"
        style={{
          animationDuration: `${props.durationInMs}ms`,
        }}
      />
    </div>
  );
};
